import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
  withRouterConfig,
} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { appReducer } from '@app/state/reducers/app.reducer';

import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import { MSALInstanceFactory, MSALGuardConfigFactory } from '@app/configs/auth-config';
import { authInterceptor } from '@app/interceptors/auth.interceptor';
import { APP_INITIALIZER, inject } from '@angular/core';
import { Store } from '@ngrx/store'; // Import Store
import { AppState } from './app/types/app.types'; // Adjust path to your AppState interface
import { setScreenAccess } from './app/state/actions/app.action'; // Adjust path to your setScreenAccess action
import { tap, catchError } from 'rxjs/operators'; // Import tap and catchError
import { of } from 'rxjs'; // Import of
import { ApiService } from '@app/services/api.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

// function loadEnv(): Promise<void> {
//   return new Promise((resolve, reject) => {
//     const script = document.createElement('script');
//     script.src = 'assets/env.js';
//     script.onload = () => resolve();
//     script.onerror = () => reject('Failed to load env.js');
//     document.head.appendChild(script);
//   });
// }

// loadEnv()
//   .then(() => {
bootstrapApplication(AppComponent, {
  providers: [
    provideStore({ app: appReducer }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes, withPreloading(PreloadAllModules), withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideIonicAngular({
      rippleEffect: false,
      mode: 'md',
    }),
    provideAnimations(), // required animations providers
    provideToastr(), // Toastr providers,
    provideCharts(withDefaultRegisterables()), // ng2-charts providers
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const store = inject(Store<AppState>);
        const apiService = inject(ApiService);

        return () =>
          apiService.getScreenAccess().pipe(
            tap((response) => {
              if (response.success) {
                store.dispatch(setScreenAccess(response.data.screen_access));
                console.log('APP_INITIALIZER: Screen access loaded and dispatched:', response.data.screen_access);
              } else {
                console.error('APP_INITIALIZER: Failed to load screen access:', response.message);
                // If API call was successful but returned success: false, dispatch empty array
                store.dispatch(setScreenAccess({ screenAccessState: [] }));
              }
            }),
            catchError((err) => {
              console.error('APP_INITIALIZER: Error fetching screen access:', err);
              // IMPORTANT: Dispatch empty array or default access in case of error.
              // The app will still proceed, but with no screen access or default access.
              store.dispatch(setScreenAccess({ screenAccessState: [] }));
              // Return an observable that completes, so APP_INITIALIZER doesn't hang
              return of(null);
            }),
          );
      },
      multi: true,
    },
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useValue: {
        interactionType: 'redirect',
        protectedResourceMap: new Map([['https://graph.microsoft.com/v1.0/me', ['user.read']]]),
      },
    },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    MsalService,
    MsalGuard,
    MsalBroadcastService, // Add this line to provide the service
  ],
  
});
// })
// .catch((err) => {
//   console.error('Bootstrap failed: ', err);
// });
